export default "__VITE_ASSET__637e3218__"